/**
 * Listing/detail variant shape: numeric stock and optional unlimited flag.
 */
export function variantHasSellableStock(v: any): boolean {
	if (v == null || typeof v !== 'object') {
		return false;
	}
	const infinite =
		v.stock_infinity === true || v.stock_infinity === 1 || v.stock_infinity === '1' || v.stock_infinity === 'true';
	if (infinite) {
		return true;
	}
	const q = Number(v.stock);
	return !Number.isNaN(q) && q > 0;
}

/** True if at least one variant can be purchased (used on grids / cards). */
export function productHasAnySellableStock(product: any): boolean {
	const variants = product?.variants;
	if (!Array.isArray(variants) || variants.length === 0) {
		return false;
	}
	return variants.some(variantHasSellableStock);
}
